<template>
  <button @click="showIntroduction" class="icons--information">information</button>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
      name: 'IntroductionToggle',
      methods: mapActions(['showIntroduction'])
    }
</script>

<style scoped>

.introduction-toggle {
  position: absolute;
  top: 40px;
  right: 40px;
}

.icons--information {
  background-image: url('../../assets/images/info.svg');
  background-repeat: no-repeat;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/introduction/Toggle.vue